import React, { useState } from 'react';
import "./Start.scss";
import "./Adaptations.scss";
import StartButton from '../../components/start-button/StartButton';
import Compass from '../../components/compass/Compass';
import ProgressiveImage from '../../components/progressive-image/ProgressiveImage';
import Loader from '../../components/loader-spinner/Loader';

export default function Start(){
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <>
      <div className="start-wrapper">
        <ProgressiveImage
          lowResSrc={"/static/UAE_map-min.jpg"}
          highResSrc={"/static/UAE_map.jpg"}
          alt={"Start Image"}
          onLoad={handleImageLoad}
        />
        <div className="button-con">
          <StartButton
            title={"abu dhabi"} 
            link={"/abu-dhabi"}
          />
          <hr />
          <StartButton
            title={"dubai"} 
            link={"/dubai"}
          />
          <hr />
          <StartButton
            title={"ras al khaimah"} 
            link={"/ras-al-khaimah"}
          />
          <Compass />
        </div>
        <Loader isVisible={!imageLoaded} nonBlocking={true} />
      </div>
    </>
  );
};
